import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';

export interface IVariantProps {
  id?: string;
  index: number;
  shouldDisplayInGrid: boolean | 0;
  content: JSX.Element;
  headingGridStyle?: string;
  isDragDisabled: boolean;
}

const DraggableOption: React.FC<IVariantProps> = ({
  id,
  index,
  shouldDisplayInGrid,
  content,
  headingGridStyle,
  isDragDisabled
}) => {
  return (
    <Draggable isDragDisabled={isDragDisabled} draggableId={id || ''} index={index}>
      {(provided) => (
        <li
          aria-labelledby={`${id}-label`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            ...provided.draggableProps.style,
            gridTemplateColumns: headingGridStyle,
            alignItems: shouldDisplayInGrid ? 'flex-start' : 'center'
          }}
          {...provided.dragHandleProps}
          data-testid="option-list-item"
        >
          {content}
        </li>
      )}
    </Draggable>
  );
};

export default DraggableOption;
